import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goacabsservice() {



    const cardData = {
"keyword": "Goa Cabs Service",

"headingDescription":
  "Om Sai Cab offers reliable and comfortable Goa Cabs Service for travelers looking for safe, affordable, and convenient local and outstation taxi solutions across Goa. Whether you are planning airport transfers, hotel pickups, beach sightseeing, family tours, honeymoon trips, corporate travel, or full-day rentals, our cab service ensures a smooth and hassle-free travel experience. With experienced local drivers familiar with Goa routes, clean air-conditioned vehicles maintained for comfort, and transparent pricing with no hidden charges, we provide a dependable transportation solution for every traveler. Our fleet includes sedans, SUVs, Innova cars, tempo travellers, and premium vehicles suitable for solo travelers, families, and groups.",

"topPlaces": [
  {
    "title": "Baga Beach",
    "description":
      "Baga Beach is one of Goa’s most popular beaches known for water sports, beach shacks, nightlife, and vibrant tourist activities."
  },
  {
    "title": "Calangute Beach",
    "description":
      "Calangute Beach is famously called the Queen of Beaches, known for its long coastline, shopping streets, seafood restaurants, and lively beach atmosphere."
  },
  {
    "title": "Fort Aguada",
    "description":
      "Fort Aguada is a well-preserved Portuguese fort offering panoramic views of the Arabian Sea, a historic lighthouse, and colonial architecture."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description":
      "Dudhsagar Waterfalls is a majestic four-tiered waterfall located in the Western Ghats, surrounded by dense forests and known for its natural beauty and adventure jeep safaris."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description":
      "The Basilica of Bom Jesus is a UNESCO World Heritage Site in Old Goa, famous for its Baroque architecture and the preserved remains of St. Francis Xavier."
  },
  {
    "title": "Anjuna Beach",
    "description":
      "Anjuna Beach is known for its bohemian vibe, flea markets, beach parties, rocky shoreline, and relaxed tourist atmosphere."
  },
  {
    "title": "Chapora Fort",
    "description":
      "Chapora Fort is a popular hilltop fort offering stunning views of Vagator Beach and the Arabian Sea, famous for sunset photography."
  },
  {
    "title": "Palolem Beach",
    "description":
      "Palolem Beach in South Goa is known for its peaceful environment, calm waters, coconut-lined shore, and relaxing beach huts."
  },
  {
    "title": "Mandovi River Cruise",
    "description":
      "Mandovi River Cruise offers evening entertainment with music, dance shows, casino views, and scenic sunset experiences in Goa."
  },
  {
    "title": "Old Goa Churches",
    "description":
      "Old Goa is home to historic churches and cathedrals such as Se Cathedral and Basilica of Bom Jesus, showcasing rich Portuguese heritage."
  }
],



services: [
  {
    name: "Taxi Service in Goa",
    description: "Taxi service in Goa provides reliable and comfortable transportation for tourists, families, couples, and business travelers exploring Goa. Vehicles ensure smooth local and outstation travel suitable for beach visits, sightseeing tours, airport transfers, and holiday travel. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from hotels, resorts, railway stations, airports, and nearby locations across Goa. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Goa Taxi Booking",
    description: "Goa taxi booking service provides easy and convenient transportation reservations for travelers planning comfortable Goa travel. Vehicles ensure reliable road journeys suitable for tourism, beach holidays, sightseeing tours, and family vacations. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby tourist locations across Goa. Flexible booking options allow convenient taxi booking reservations."
  },
  {
    name: "Goa Cabs",
    description: "Goa cabs service offers dependable transportation for tourists and travelers planning smooth travel across Goa and nearby destinations. Comfortable vehicles ensure reliable road journeys suitable for sightseeing trips, beach holidays, and family outings. Professional chauffeurs ensure punctual pickup and safe driving services throughout the route. Pickup services are available from hotels, airports, railway stations, resorts, and nearby areas across Goa. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Cheapest Cab Service in Goa",
    description: "Cheapest cab service in Goa provides budget-friendly transportation for solo travelers, couples, tourists, and families visiting Goa. Comfortable vehicles ensure smooth local and outstation travel suitable for sightseeing, beach visits, and tourism travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the journey. Pickup services are available from hotels, resorts, railway stations, airports, and nearby tourist areas across Goa. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Goa Cab Booking",
    description: "Goa cab booking service offers reliable transportation reservations for travelers planning safe and comfortable Goa travel. Vehicles ensure smooth road journeys suitable for beach holidays, tourism trips, airport transfers, and sightseeing tours. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from hotels, airports, resorts, railway stations, and nearby locations across Goa. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Cab Booking in Goa",
    description: "Cab booking in Goa service provides comfortable transportation solutions for tourists and families planning convenient travel in Goa. Vehicles ensure reliable local and outstation journeys suitable for holiday travel and sightseeing tours. Professional chauffeurs ensure safe driving and dependable pickup services throughout the trip. Pickup services are available from hotels, resorts, airports, railway stations, and nearby tourist spots across Goa. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Online Taxi Service in Goa",
    description: "Online taxi service in Goa provides quick and convenient transportation booking for travelers planning smooth Goa travel experiences. Comfortable vehicles ensure reliable journeys suitable for beach tourism, sightseeing tours, and airport transfers. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from hotels, airports, railway stations, and nearby locations across Goa. Flexible online booking options allow convenient taxi reservations."
  },
  {
    name: "Best Taxi Service in Goa",
    description: "Best taxi service in Goa provides premium transportation with comfortable vehicles and experienced chauffeurs for smooth travel experiences. Vehicles ensure reliable road journeys suitable for tourism, sightseeing, beach holidays, and family vacations. Professional chauffeurs ensure dependable pickup and safe driving services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby tourist areas across Goa. Flexible booking options allow convenient premium taxi reservations."
  },
  {
    name: "Online Cab Booking Goa",
    description: "Online cab booking Goa service provides easy transportation reservations for travelers planning comfortable travel across Goa. Vehicles ensure smooth and reliable journeys suitable for tourism travel, beach holidays, sightseeing tours, and family trips. Professional chauffeurs ensure safe driving and dependable pickup services throughout the route. Pickup services are available from hotels, airports, railway stations, resorts, and nearby tourist locations across Goa. Flexible online booking options allow convenient cab reservations."
  },
  {
    name: "Cheap Taxi in Goa",
    description: "Cheap taxi in Goa service offers affordable transportation for tourists and travelers seeking economical travel options in Goa. Comfortable vehicles ensure smooth local travel suitable for beach visits, sightseeing tours, and airport transfers. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the journey. Pickup services are available from hotels, resorts, airports, railway stations, and nearby areas across Goa. Flexible booking options allow convenient low-cost taxi reservations."
  },
  {
    name: "Cheapest Taxi Service in Goa",
    description: "Cheapest taxi service in Goa provides budget-friendly transportation for tourists, couples, and families planning affordable Goa travel. Vehicles ensure reliable road journeys suitable for local sightseeing, tourism travel, and beach holidays. Professional chauffeurs ensure safe driving and punctual pickup services throughout the trip. Pickup services are available from hotels, resorts, railway stations, airports, and nearby tourist areas across Goa. Flexible booking options allow convenient economical taxi reservations."
  },
  {
    name: "Goa Airport Taxi Booking",
    description: "Goa airport taxi booking service provides direct airport transportation for travelers arriving at Goa Airport and nearby locations. Comfortable vehicles ensure smooth airport transfers suitable for tourism travel, family vacations, and business journeys. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the route. Pickup services are available from airport terminals, nearby hotels, and resorts across Goa. Flexible booking options allow convenient airport taxi reservations."
  },
  {
    name: "Taxi Fare in Goa",
    description: "Taxi fare in Goa service provides affordable and transparent transportation pricing for travelers planning local and outstation Goa travel. Vehicles ensure comfortable journeys suitable for sightseeing tours, tourism trips, and airport transfers. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the journey. Pickup services are available from hotels, airports, resorts, railway stations, and nearby areas across Goa. Flexible booking options allow convenient taxi fare reservations."
  },
  {
    name: "Online Taxi Booking in Goa",
    description: "Online taxi booking in Goa service provides convenient transportation reservations for travelers planning safe and smooth Goa travel. Comfortable vehicles ensure reliable journeys suitable for beach holidays, tourism travel, and family outings. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from hotels, airports, resorts, railway stations, and nearby tourist locations across Goa. Flexible online booking options allow convenient taxi reservations."
  },
  {
    name: "Goa to Navi Mumbai Cab Service",
    description: "Goa to Navi Mumbai cab service provides reliable long-distance transportation for travelers planning comfortable road journeys from Goa to Navi Mumbai. Vehicles ensure smooth highway travel suitable for tourism, family travel, and business trips. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby locations across Goa. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Goa to Navi Mumbai Taxi Service",
    description: "Goa to Navi Mumbai taxi service offers dependable transportation with comfortable vehicles for travelers returning from Goa to Navi Mumbai. Vehicles ensure reliable highway journeys suitable for tourism, sightseeing tours, and family vacations. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby areas across Goa. Flexible booking options allow convenient taxi service reservations."
  },
  {
    name: "Goa to Navi Mumbai Cab",
    description: "Goa to Navi Mumbai cab service provides comfortable transportation for passengers planning direct road travel from Goa to Navi Mumbai. Vehicles ensure smooth highway journeys suitable for long-distance tourism and family travel. Professional chauffeurs ensure dependable pickup and safe driving services throughout the route. Pickup services are available from hotels, airports, resorts, railway stations, and nearby locations across Goa. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Goa to Navi Mumbai Taxi",
    description: "Goa to Navi Mumbai taxi service offers reliable transportation for travelers seeking smooth and safe road journeys to Navi Mumbai. Comfortable vehicles ensure dependable highway travel suitable for tourism trips, business travel, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby areas across Goa. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Goa to Navi Mumbai One Way Cab",
    description: "Goa to Navi Mumbai one way cab service provides economical transportation for travelers requiring direct one-side travel to Navi Mumbai. Vehicles ensure smooth highway journeys suitable for solo travelers, tourists, and family travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from hotels, airports, resorts, railway stations, and nearby locations across Goa. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Goa to Navi Mumbai Outstation Cab",
    description: "Goa to Navi Mumbai outstation cab service provides dependable long-distance transportation for comfortable intercity travel. Comfortable vehicles ensure reliable highway journeys suitable for tourism, family vacations, and business travel. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby areas across Goa. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Goa to Navi Mumbai Car Rental",
    description: "Goa to Navi Mumbai car rental service provides spacious and comfortable vehicles for travelers planning private road journeys. Vehicles ensure smooth highway travel suitable for tourism trips, holiday travel, and long-distance family travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from hotels, airports, resorts, railway stations, and nearby locations across Goa. Flexible booking options allow convenient car rental reservations."
  },
  {
    name: "Goa to Navi Mumbai Innova Cab",
    description: "Goa to Navi Mumbai Innova cab service provides spacious transportation for families and groups planning comfortable long-distance travel. Innova vehicles ensure smooth highway journeys with comfortable seating and luggage capacity suitable for tourism and holiday travel. Professional chauffeurs ensure reliable pickup and safe transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby areas across Goa. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Goa to Navi Mumbai Innova Crysta Cab",
    description: "Goa to Navi Mumbai Innova Crysta cab service offers luxury transportation with premium interiors and smooth highway performance. Innova Crysta vehicles are suitable for executive travel, tourism trips, family vacations, and VIP transportation. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby locations across Goa. Flexible booking options allow convenient Innova Crysta cab reservations."
  },
  {
    name: "Goa to Navi Mumbai Ertiga Cab",
    description: "Goa to Navi Mumbai Ertiga cab service provides affordable and spacious transportation for small families and groups traveling to Navi Mumbai. Ertiga vehicles ensure reliable highway journeys suitable for tourism, sightseeing tours, and family travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from hotels, airports, resorts, railway stations, and nearby areas across Goa. Flexible booking options allow convenient Ertiga cab reservations."
  },
  {
    name: "Goa to Navi Mumbai Sedan Cab",
    description: "Goa to Navi Mumbai sedan cab service offers comfortable transportation for solo travelers, couples, and business passengers. Sedan vehicles ensure smooth and safe highway travel suitable for long-distance journeys and tourism travel. Professional chauffeurs ensure dependable pickup and reliable transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby areas across Goa. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "Goa to Navi Mumbai SUV Cab",
    description: "Goa to Navi Mumbai SUV cab service provides spacious transportation for travelers seeking premium and comfortable road journeys. SUV vehicles ensure reliable highway travel suitable for tourism, family vacations, and group travel. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from hotels, airports, resorts, railway stations, and nearby locations across Goa. Flexible booking options allow convenient SUV cab reservations."
  },
  {
    name: "Goa to Navi Mumbai Luxury Cab",
    description: "Goa to Navi Mumbai luxury cab service provides premium transportation with luxury vehicles suitable for stylish and comfortable road travel. Vehicles ensure smooth highway journeys ideal for tourism, executive travel, family holidays, and VIP transportation. Professional chauffeurs ensure dependable pickup and premium transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby areas across Goa. Flexible booking options allow convenient luxury cab reservations."
  },
  {
    name: "Best Goa Cab Service",
    description: "Best Goa cab service provides premium transportation with comfortable vehicles and experienced chauffeurs for smooth local and outstation Goa travel. Vehicles ensure reliable journeys suitable for beach holidays, sightseeing tours, airport transfers, and tourism travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from hotels, airports, resorts, railway stations, and nearby tourist areas across Goa. Flexible booking options allow convenient premium cab reservations."
  },
  {
    name: "Goa Tourist Cab Booking",
    description: "Goa tourist cab booking service offers dependable transportation for tourists planning comfortable sightseeing and holiday travel across Goa. Vehicles ensure smooth local and outstation journeys suitable for beach visits, tourism tours, and family outings. Professional chauffeurs ensure safe driving and reliable pickup services throughout the trip. Pickup services are available from hotels, airports, resorts, railway stations, and nearby locations across Goa. Flexible booking options allow convenient tourist cab reservations."
  },
  {
    name: "Goa to Mumbai Cab Booking",
    description: "Goa to Mumbai cab booking service provides convenient transportation reservations for travelers planning comfortable return road journeys to Mumbai. Comfortable vehicles ensure smooth highway travel suitable for tourism, family holidays, and business travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby areas across Goa. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Goa to Mumbai Taxi Service",
    description: "Goa to Mumbai taxi service offers reliable long-distance transportation for travelers seeking safe and comfortable travel from Goa to Mumbai. Vehicles ensure smooth highway journeys suitable for tourism travel, family outings, and executive journeys. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby locations across Goa. Flexible booking options allow convenient taxi service reservations."
  }
],

tableData: [
  ["Taxi Service in Goa", "Goa Taxi Booking"],
  ["Goa Cabs", "Cheapest Cab Service in Goa"],
  ["Goa Cab Booking", "Cab Booking in Goa"],
  ["Online Taxi Service in Goa", "Best Taxi Service in Goa"],
  ["Online Cab Booking Goa", "Cheap Taxi in Goa"],
  ["Cheapest Taxi Service in Goa", "Goa Airport Taxi Booking"],
  ["Taxi Fare in Goa", "Online Taxi Booking in Goa"],
  ["Goa to Navi Mumbai Cab Service", "Goa to Navi Mumbai Taxi Service"],
  ["Goa to Navi Mumbai Cab", "Goa to Navi Mumbai Taxi"],
  ["Goa to Navi Mumbai One Way Cab", "Goa to Navi Mumbai Outstation Cab"],
  ["Goa to Navi Mumbai Car Rental", "Goa to Navi Mumbai Innova Cab"],
  ["Goa to Navi Mumbai Innova Crysta Cab", "Goa to Navi Mumbai Ertiga Cab"],
  ["Goa to Navi Mumbai Sedan Cab", "Goa to Navi Mumbai SUV Cab"],
  ["Goa to Navi Mumbai Luxury Cab", "Best Goa Cab Service"],
  ["Goa Tourist Cab Booking", "Goa to Mumbai Cab Booking"],
  ["Goa to Mumbai Taxi Service", "Taxi Service in Goa"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Goa to Mumbai Cab Service",
    WhyChoosedescription: "Om Sai Cab Service provides reliable Goa to Mumbai cab service with professional drivers, comfortable vehicles, and smooth long-distance travel for tourists, families, and business travelers."
  },
  {
    WhyChooseheading: "Affordable Goa to Mumbai Taxi Fare",
    WhyChoosedescription: "Our Goa to Mumbai taxi service offers affordable pricing with transparent fare details and no hidden charges for one-way and round-trip travel bookings."
  },
  {
    WhyChooseheading: "24/7 Goa to Mumbai Taxi Availability",
    WhyChoosedescription: "Om Sai Cab Service operates 24 hours a day for Goa to Mumbai cab bookings including airport transfers, hotel pickups, family travel, and emergency outstation journeys."
  },
  {
    WhyChooseheading: "Comfortable AC Cabs for Long Distance Travel",
    WhyChoosedescription: "All Goa to Mumbai taxis are fully air-conditioned, sanitized, spacious, and maintained regularly for smooth and comfortable highway travel experiences."
  },
  {
    WhyChooseheading: "One Way & Private Taxi Booking Options",
    WhyChoosedescription: "Customers can book one-way Goa to Mumbai cabs, private taxi services, round-trip travel, airport transfers, and customized outstation travel packages."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Choices",
    WhyChoosedescription: "Om Sai Cab Service offers sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and luxury vehicles suitable for solo travelers, families, and group tours."
  },
  {
    WhyChooseheading: "Pickup from North Goa, South Goa & Airport",
    WhyChoosedescription: "We provide doorstep pickup from North Goa, South Goa, Panaji, Baga, Calangute, Candolim, Vasco, Madgaon, Goa Airport, hotels, resorts, and all major tourist locations."
  },
  {
    WhyChooseheading: "Experienced Drivers for Mumbai Highway Routes",
    WhyChoosedescription: "Our experienced drivers are familiar with Goa to Mumbai highway routes and ghat sections, ensuring safe driving, smooth journeys, and timely arrival."
  }
]
};

const faqData = [
  {
    question: "What is Goa cabs service?",
    answer: "Goa cabs service provides reliable taxi transportation across Goa for airport transfers, local sightseeing, hotel pickups, and outstation travel."
  },
  {
    question: "Is Goa cabs service available 24 hours?",
    answer: "Yes, Om Sai Cab Service provides 24/7 Goa cab booking service for both local and outstation travel."
  },
  {
    question: "Which types of vehicles are available in Goa cabs service?",
    answer: "Customers can book hatchbacks, sedans, SUVs, Ertiga, Innova, Innova Crysta, and luxury cars depending on travel needs."
  },
  {
    question: "Can I book Goa cabs for airport pickup and drop?",
    answer: "Yes, Goa airport pickup and drop services are available for both domestic and international flights."
  },
  {
    question: "Do you provide Goa sightseeing cab packages?",
    answer: "Yes, we provide customized Goa sightseeing cab packages covering beaches, churches, forts, and popular tourist attractions."
  },
  {
    question: "Are Goa cabs available for outstation travel?",
    answer: "Yes, Goa cabs are available for outstation trips to Mumbai, Pune, Bangalore, Hyderabad, and other major cities."
  },
  {
    question: "Can I book a one-way cab from Goa?",
    answer: "Yes, one-way cab booking from Goa is available for multiple destinations at affordable prices."
  },
  {
    question: "Are the Goa cabs air-conditioned?",
    answer: "Yes, all cabs are fully air-conditioned and regularly maintained for a comfortable travel experience."
  },
  {
    question: "How can I book Goa cabs service?",
    answer: "You can book Goa cabs service online through our website or by contacting our customer support via phone or WhatsApp."
  },
  {
    question: "Are Goa cab fares fixed and transparent?",
    answer: "Yes, Om Sai Cab Service offers transparent pricing with no hidden charges and affordable fare options."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akash Verma",
    feedback: "Relied on Om Sai Cab Service during our Goa vacation and received excellent service throughout. The cab was well-maintained, and the driver was knowledgeable about local routes and attractions.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Sharma",
    feedback: "Exploring Goa became much easier with Om Sai Cab Service. The vehicle was clean, the driver was polite, and every ride was comfortable and punctual.",
    rating: 5
  }
];


















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai to Goa Cab", link: "Mumbai-to-Goa-Cab" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Goa Cab Booking", link: "Mumbai-to-Goa-Cab-Booking" },
        { place: "/images/keyword/3.jpg", text: "Navi Mumbai to Goa Cab Service", link: "Navi-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/4.jpg", text: "Mumbai Airport to Goa Cab", link: "Mumbai-Airport-to-Goa-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Goa Cab Service", link: "Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Best Mumbai to Goa Cab Service", link: "Best-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/7.jpg", text: "Thane to Goa Cabs", link: "Thane-to-Goa-Cabs" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Goa Innova Crysta Cab", link: "Mumbai-to-Goa-Innova-Crysta-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Goa One Way Cab", link: "Mumbai-to-Goa-One-Way-Cab" },
        { place: "/images/keyword/10.jpg", text: "Goa Cabs Service", link: "Goa-Cabs-Service" },
        { place: "/images/keyword/11.jpg", text: "Goa to Mumbai Cab", link: "Goa-to-Mumbai-Cab" },
        { place: "/images/keyword/12.jpg", text: "Goa to Navi Mumbai Cab", link: "Goa-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/13.jpg", text: "Goa to Mumbai Airport Cab", link: "Goa-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/14.jpg", text: "Goa to Mumbai One Way Cab", link: "Goa-to-Mumbai-One-Way-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/16.jpg", text: "Lonavala to Mumbai Cab", link: "Lonavala-to-Mumbai-Cab" },
        { place: "/images/keyword/17.jpg", text: "Best Lonavala to Navi Mumbai Cab", link: "Best-Lonavala-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/18.jpg", text: "Navi Mumbai Airport Cab", link: "Navi-Mumbai-Airport-Cab" },
        { place: "/images/keyword/19.jpg", text: "Navi Mumbai Cab Service", link: "Navi-Mumbai-Cab-Service" },
        { place: "/images/keyword/20.jpg", text: "Kharghar Taxi Services", link: "Kharghar-Taxi-Services" },
        { place: "/images/keyword/21.jpg", text: "Mumbai Airport Cabs", link: "Mumbai-Airport-Cabs" },
        { place: "/images/keyword/22.jpg", text: "Mumbai Cab Service", link: "Mumbai-Cab-Service" },
        { place: "/images/keyword/23.jpg", text: "Mumbai Online Cab Service", link: "Mumbai-Online-Cab-Service" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/25.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/26.jpg", text: "Innova Crysta On Rent in Mumbai", link: "Innova-Crysta-On-Rent-in-Mumbai" },
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Goa Cabs Service",
  "image": "http://www.omsaicabservice.com/assets/images/goa-cabs-service.jpg",
  "description": "Book Goa cab service with Om Sai Cab Service for local travel, airport transfers, and outstation trips. Affordable taxi booking in Goa including sedan, SUV, Ertiga, Innova, and Innova Crysta cabs with 24x7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Om Sai Cab Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "http://www.omsaicabservice.com/goa-cabs-service"
  }
};




    return (
        <div>

<Helmet>
  <title>
    Goa Cabs Service | Affordable Taxi Booking in Goa | +91 9594849797
  </title>

  <meta
    name="description"
    content="Book Goa cab service for local travel, airport transfers, and outstation trips. Affordable taxi booking in Goa with Sedan, SUV, Ertiga, Innova, and luxury cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Taxi service in goa, Goa taxi booking, goa cabs, cheapest cab service in goa, Goa cab booking, Cab booking in goa, Online taxi service in goa, best taxi service in goa, online cab booking goa, cheap taxi in goa, cheapest taxi service in goa, Goa airport taxi booking, taxi fare in goa, Online taxi booking in goa, Goa to Navi Mumbai Cab Service, Goa to Navi Mumbai Taxi Service, Goa to Navi Mumbai Cab, Goa to Navi Mumbai Taxi, Goa to Navi Mumbai One Way Cab, Goa to Navi Mumbai Outstation Cab, Goa to Navi Mumbai Car Rental, Goa to Navi Mumbai Innova Cab, Goa to Navi Mumbai Innova Crysta Cab, Goa to Navi Mumbai Ertiga Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FFCC00', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Om Sai Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Om Sai Cab</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Om Sai Cab </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                             <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919594849797" className="pc-call">+91 9594849797</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919594849797"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919594849797" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@omsaicabservice.com" className="pc-email">
                                            booking@omsaicabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Om Sai Cab Service</strong><br />
                                            Shree Vishal CHS Ltd., Plot No.17,
                                            Sector 18, Kopar Khairane, Navi Mumbai,
                                            Maharashtra- India - 400709
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Goacabsservice;